__turbopack_context__.v({
  "imageContainer": "styles-module__h5Qn7a__imageContainer",
  "pulse": "styles-module__h5Qn7a__pulse",
  "shimmer": "styles-module__h5Qn7a__shimmer",
  "skeleton": "styles-module__h5Qn7a__skeleton",
  "skeletonPulse": "styles-module__h5Qn7a__skeletonPulse",
});
